module.exports = {
  projectName: 'Sun',
  eng: 'Englisch',
  de: 'Deutsch',
  error404: 'The page you are looking for does not exist!',
};



// WEBPACK FOOTER //
// ./src/lang/de/global.js